import type { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitCallAction extends WorkerAction {
  type: GitAction.Call;
  params: { commands: string[] };
}

export async function GitCallActionFn({ lg, params, util }: WorkerFnParams<GitCallAction>): Promise<string> {
  const { commands } = params;
  const stdout = await lg.callAndCaptureOutput(commands);
  await util.syncfs(false);
  return stdout;
}
